import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';
import { AuthorizedPartner } from 'interfaces';

export const authorizedPartnersService = {
  getAll: (): Promise<AuthorizedPartner[]> =>
    axiosService.get(AXIOS_URLS.authorized_partners).then((res) => res.data),
};

